export default __webpack_public_path__ + "static/media/SignalsImg.d8a6e9f5.jpg";